<template>
  <v-card>
    <v-card-text>
      <h2 id="staffSignature">Signature</h2>
      <v-btn :to="{ name: 'emailSignature', params: { id: $route.params.id } }">
        <v-icon>add</v-icon>Signature
      </v-btn>
      <template v-if="entity.emailSignature">
        <div class="ajaxForm">
          <v-btn
            style="float: right"
            v-clipboard:copy="computedHtml"
            v-clipboard:success="onCopy"
            v-clipboard:error="onError"
          >
            <v-icon>content_paste</v-icon>
          </v-btn>
          <span v-html="computedHtml" />
        </div>
        <div class="ajaxForm">
          <v-btn
            style="float: right"
            v-clipboard:copy="computedText"
            v-clipboard:success="onCopy"
            v-clipboard:error="onError"
          >
            <v-icon>content_paste</v-icon>
          </v-btn>
          <span style="white-space: pre-wrap">{{ computedText }}</span>
        </div>
      </template>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "EmailSignature",
  props: ["entity"],
  computed: {
    computedHtml() {
      if (!this.entity.emailSignature) {
        return undefined;
      }
      return (
        this.entity.emailSignature.html +
        this.entity.emailSignature.htmlPromotion +
        this.entity.emailSignature.htmlWarnings
      );
    },
    computedText() {
      if (!this.entity.emailSignature) {
        return undefined;
      }
      return (
        this.entity.emailSignature.text +
        this.entity.emailSignature.textPromotion +
        this.entity.emailSignature.textWarnings
      );
    }
  },
  methods: {
    onCopy() {
      alert("Copied to clipboard");
    },
    onError() {
      alert("Failed to copy texts");
    }
  }
};
</script>
